module.exports = __webpack_public_path__ + "static/03-2eb040bca3db7f6a5fda6c8baeecaa56.png";